import React from "react";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const TableContainer = styled.div`
  margin: 20px !important;
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 14px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
`;

const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 130px;
  height: 35px;
  margin-right: 20px;
  margin-top: 25px;
`;

const SubcriptionDetails = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <div>
      <TableContainer>
        <table className="table">
          <thead>
            <tr className="heading_row">
              <th>{t["Day of week"]}</th>
              <th>{t["Working hrs Start"]}</th>
              <th>{t["Working Mins Start"]}</th>
              <th>{t["Workings hrs End"]}</th>
              <th>{t["Workings mins End"]} </th>
            </tr>
          </thead>
          <tbody>
            <tr>{/* Data */}</tr>
          </tbody>
        </table>
      </TableContainer>
      <ActionButton>+ Add Branch</ActionButton>
    </div>
  );
};

export default SubcriptionDetails;
